import React, { useState } from 'react';
import { BriefcaseIcon, PlusIcon } from '@heroicons/react/24/outline';
import CommonPageHeader from '../components/common/CommonPageHeader';
import DealList from '../components/deals/DealList';
import { useLanguage } from '../contexts/LanguageContext';

const Deals = () => {
  const { t } = useLanguage();
  const [isFormOpen, setIsFormOpen] = useState(false);
  
  const handleNewDeal = () => {
    setIsFormOpen(true);
  };
  
  return (
    <div className="space-y-6">
      <CommonPageHeader
        title={t('deals.title')}
        subtitle="Ügyletek és lehetőségek kezelése"
        icon={BriefcaseIcon}
        showLastUpdate={false}
      >
        <button
          onClick={handleNewDeal}
          className="inline-flex items-center px-4 py-2 bg-white/20 backdrop-blur-sm text-white rounded-lg hover:bg-white/30 transition-colors"
        >
          <PlusIcon className="w-5 h-5 mr-2" />
          {t('deals.new')}
        </button>
      </CommonPageHeader>

      <DealList isFormOpen={isFormOpen} setIsFormOpen={setIsFormOpen} />
    </div>
  );
};

export default Deals; 